import { createContext } from "react";
import { createUseContextHook } from "~/utils/createUseContextHook";

export const PortalContainerContext = createContext<{
  container: HTMLElement;
} | null>(null);

export const usePortalContainerContext = createUseContextHook(PortalContainerContext, "PortalContainerContext");
